import api from "../config/api";

const logQueue = [];
let flushTimer = null;

const flushLogs = async () => {
  if (logQueue.length === 0) return;
  const batch = logQueue.splice(0, logQueue.length);

  try {
    await api.post("/admin/activity-logs", {
      source: "user_webapp",
      level: "error",
      category: "api",
      event: "BATCH_API_ERRORS",
      message: `Batch of ${batch.length} client-side errors`,
      metadata: { batch },
    });
  } catch (err) {
    // Logging failures must not break the app.
    if (process.env.NODE_ENV !== "production") {
      console.error("[ActivityLog] Failed to ship logs:", err);
    }
  }
};

const scheduleFlush = () => {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushLogs();
  }, 5000);
};

export const logActivity = (level, category, event, message, metadata = {}) => {
  const entry = {
    source: "user_webapp",
    level,
    category,
    event,
    message,
    metadata: {
      ...metadata,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    },
  };

  // For fatal/render errors, send immediately; otherwise queue.
  if (level === "fatal") {
    api
      .post("/admin/activity-logs", entry)
      .catch(() => {});
  } else {
    logQueue.push(entry);
    scheduleFlush();
  }
};

export const logApiError = (error) => {
  const status = error?.response?.status;
  const url = error?.config?.url;
  const method = error?.config?.method;

  logActivity(
    status >= 500 ? "error" : "warn",
    "api",
    "API_ERROR",
    error?.message || "API request failed",
    {
      status,
      url,
      method,
      responseData: error?.response?.data,
    }
  );
};

export const flushActivityLogs = flushLogs;

// Flush on page hide/unload
window.addEventListener("beforeunload", flushLogs);
